import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=7f063104&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=7f063104&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f063104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f063104')) {
      api.createRecord('7f063104', component.options)
    } else {
      api.reload('7f063104', component.options)
    }
    module.hot.accept("./Language.vue?vue&type=template&id=7f063104&scoped=true", function () {
      api.rerender('7f063104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Language/Language.vue"
export default component.exports